import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./config/i18n";
import { UserProvider, useUserContext } from "./Contexts/userContext.tsx";
import {
  StudentsProvider,
  useStudentsContext,
} from "./Contexts/StudentsContext.tsx";
import { GuardiansProvider } from "./Contexts/GuardiansContext.tsx";
import {
  SchoolsProvider,
  useSchoolsContext,
} from "./Contexts/schoolContext.tsx";
import {
  DashboardsProvider,
  useDashboardContext,
} from "./Contexts/DashboardContext.tsx";
import { NotificationProvider } from "./Contexts/NotificationContext.tsx";
import { CombinedLoadingsProvider } from "./Contexts/CombinedLoadingContext.tsx";
import { BrowserRouter } from "react-router-dom";
import { GlobalErrorProvider } from "./Contexts/GlobalErrorContext";
import { ChakraProvider } from "@chakra-ui/react";
import { ColorModeProvider } from "./Components/ui/color-mode";
import { system } from "./services/theme";
import { Toaster } from "./Components/ui/toaster.tsx";

const AppWithProviders = () => {
  const { isLoading: userLoading } = useUserContext();
  const { isLoading: dashboardLoading } = useDashboardContext();
  const { isLoading: schoolsLoading } = useSchoolsContext();
  const { isLoading: studentsLoading } = useStudentsContext();

  return (
    <CombinedLoadingsProvider
      userLoading={userLoading}
      dashboardLoading={dashboardLoading}
      schoolsLoading={schoolsLoading}
      studentsLoading={studentsLoading}
    >
      <App />
    </CombinedLoadingsProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <GlobalErrorProvider>
      <ChakraProvider value={system}>
        <ColorModeProvider>
          <BrowserRouter>
            <UserProvider>
              <SchoolsProvider>
                <StudentsProvider>
                  <GuardiansProvider>
                    <DashboardsProvider>
                      <NotificationProvider>
                        <AppWithProviders />
                      </NotificationProvider>
                    </DashboardsProvider>
                  </GuardiansProvider>
                </StudentsProvider>
              </SchoolsProvider>
            </UserProvider>
          </BrowserRouter>
          <Toaster />
        </ColorModeProvider>
      </ChakraProvider>
    </GlobalErrorProvider>
   
  </React.StrictMode>
);
